import styled from 'styled-components';
import { theme } from 'styled-tools';

export const TitleWrapper = styled.div`
    ${theme('commonPadding')}
    
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const ProfileWrapper = styled.div`
    cursor: pointer;
`;

export const ContentsContainer = styled.div`
    max-width: 474px;
    margin: 120px auto 0 auto;
    /* padding-left: 20px;
    padding-right: 20px; */
    padding-bottom: 60px;
    position: relative;
`;